<template>
  <div>
  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      form: {},
      url:"",
    };
  },
  components: {},
  created() {
    this.url= window.decodeURIComponent(this.$route.query.url)
  },
  methods: {
  }
};
</script>

<style>
  iframe{
    border: 0;
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/views/web.vue